<template>
  <div class="login-container">
    <div class="left">
      <img class="logo" src="../../assets/img/login/login.png" alt />
    </div>
    <div class="right">
      <div class="title-container">
        登录
        <!-- <img class="logo" src="../../assets/img/login/loginlogo.png" alt /> -->
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="手机验证码登录" name="first"></el-tab-pane>
        <el-tab-pane label="账号密码登录" name="second"></el-tab-pane>
      </el-tabs>
      <div class="formstyle">
        <el-form
          v-show="activeName=='first'"
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          autocomplete="on"
          label-position="left"
        >
          <el-form-item prop="phone">
            <!-- <span class="svg-container">
              <img class="icon" src="../../assets/img/login/user.png" alt />
            </span>-->
            <el-input
              v-model="loginForm.phone"
              placeholder="请输入手机号"
              name="phone"
              type="text"
              tabindex="1"
              autocomplete="on"
            >
              <i slot="prefix">
                <img
                  class="icon"
                  src="../../assets/img/login/user.png"
                  style="margin-top:12px;"
                  alt
                />
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="phoneCode">
            <!-- <span class="svg-container">
              <img class="icon" src="../../assets/img/login/password.png" alt />
            </span>-->
            <el-input
              :key="codeType"
              v-model="loginForm.phoneCode"
              placeholder="请输入动态码"
              name="phoneCode"
              tabindex="2"
              autocomplete="on"
            >
              <i slot="prefix">
                <img
                  class="icon"
                  src="../../assets/img/login/password.png"
                  style="margin-top:12px;"
                  alt
                />
              </i>
            </el-input>
            <el-button
              type="primary"
              :disabled="disabledCodeBtn"
              @click="getMessagePwd"
              style="background:#ff854c;border-color:#ff854c;margin-left:10px;margin-top:8px;"
            >{{codeButton}}</el-button>
          </el-form-item>
          <el-button
            type="primary"
            style="width:100%;height:50px;margin-bottom:30px;margin-top:20px;background:rgb(255, 133, 76);border-color: rgb(255, 133, 76);border-radius:25px;font-size:18px;"
            @click.native.prevent="phoneLogin"
          >登录</el-button>
        </el-form>
        <el-form
          v-show="activeName=='second'"
          ref="loginForm1"
          :model="loginForm1"
          :rules="loginRules1"
          class="login-form"
          autocomplete="on"
          label-position="left"
        >
          <el-form-item prop="userName">
            <!-- <span class="svg-container">
              <img class="icon" src="../../assets/img/login/user.png" alt />
            </span>-->
            <el-input
              v-model="loginForm1.userName"
              placeholder="请输入用户名/手机号码"
              name="userName"
              type="text"
              tabindex="1"
              autocomplete="on"
            >
              <i slot="prefix">
                <img
                  class="icon"
                  src="../../assets/img/login/user.png"
                  style="margin-top:12px;"
                  alt
                />
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="passWord">
            <!-- <span class="svg-container">
              <img class="icon" src="../../assets/img/login/password.png" alt />
            </span>-->
            <el-input
              :key="passwordType"
              v-model="loginForm1.passWord"
              :type="passwordType"
              placeholder="请输入密码"
              name="passWord"
              tabindex="2"
              autocomplete="on"
            >
              <i slot="prefix">
                <img
                  class="icon"
                  src="../../assets/img/login/password.png"
                  style="margin-top:12px;"
                  alt
                />
              </i>
            </el-input>
          </el-form-item>
          <el-button
            type="primary"
            style="width:100%;height:50px;margin-bottom:30px;margin-top:20px;background:rgb(255, 133, 76);border-color: rgb(255, 133, 76);border-radius:25px;font-size:18px;"
            @click.native.prevent="checkLogin"
          >登录</el-button>
        </el-form>
      </div>
      <div class="tipstyle">
        <el-button v-show="activeName==='second'" type="text" size="small" @click="forgetPwd">忘记密码</el-button>
        <span>
          <!-- 还没有账号？ -->
          <span
            class="register"
            @click="goRegister"
            :style="{'margin-left': activeName=='second' ? '168px' : '400px'}"
          >立即注册</span>
        </span>
        <!-- <p class="contact">如有需要，请联系：15210925572</p> -->
        <!-- <p class="suggest">为了给您更好的体验，推荐使用Chrome浏览器</p> -->
      </div>
      <register-module :dialogVisible="dialogVisible" @handleClosed="registerClosed"></register-module>
      <getback-password
        :pwdDialogVisible="pwdDialogVisible"
        @handleClosed="forgetpwdClosed"
        :isback="true"
      ></getback-password>
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
import { sendLoginInfo, getMessagePwd, handlePhoneLogin } from "@/api/login";
import { mapMutations } from "vuex";
import registerModule from "@/pages/login/register.vue";
import getbackPassword from "@/pages/login/forgetpwd.vue";
export default {
  name: "Login",
  components: {
    registerModule,
    getbackPassword
  },
  data() {
    var validateTel = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!myreg.test(value)) {
        callback(new Error("请正确输入手机号"));
      }
      callback();
    };
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名/手机号码"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      activeName: "second",
      // 表单数据
      loginForm: {
        phone: "",
        phoneCode: ""
      },
      loginForm1: {
        userName: "",
        passWord: ""
      },
      // 表单验证
      loginRules: {
        phone: [{ required: true, validator: validateTel, trigger: "blur" }],
        phoneCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      loginRules1: {
        userName: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        passWord: [
          { required: true, trigger: "blur", validator: validatePassword }
        ]
      },
      passwordType: "password", // input type  password
      codeType: "phoneCode", // input type  password
      dialogVisible: false, //马上注册弹框
      pwdDialogVisible: false, //忘记密码弹框
      disabledCodeBtn: false, // 获取验证码点击
      codeButton: "获取验证码",
      num: 60,
      timer: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations(["SET_USERINFO", "SET_AUTHORIZATION"]),
    // 获取动态码
    async getMessagePwd() {
      if (!this.loginForm.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(this.loginForm.phone)) {
        // this.$message.error("请正确输入手机号");
        return;
      }
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          this.handlePhoneLogin();
        } else {
          return false;
        }
      });
      let params = {
        phone: this.loginForm.phone
      };
      let data = await getMessagePwd(params);
      if (data.status === 200) {
        this.$message({
          message: "验证码已发送",
          type: "success"
        });
        this.disabledCodeBtn = true;
        this.num = 60;
        this.timer = setInterval(() => {
          if (this.num < 2) {
            clearInterval(this.timer);
            this.disabledCodeBtn = false;
            this.codeButton = "获取验证码";
            this.num = 60;
            return;
          }
          this.num--;
          this.codeButton = this.num + "秒后重新发送";
        }, 1000);
      } else {
        this.$message({
          message: "获取验证码失败，请稍后重试",
          type: "error"
        });
      }
    },
    // 手机验证码登录
    phoneLogin() {
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          this.handlePhoneLogin();
        } else {
          return false;
        }
      });
    },
    async handlePhoneLogin() {
      let data = await handlePhoneLogin(this.loginForm);
      // 用户信息存储
      if (data.status === 200) {
        // 不需要权限 删除auth属性
        let userinfo = JSON.parse(data.headers.userinfo);
        delete userinfo.auth;
        this.SET_USERINFO(userinfo);
        this.SET_AUTHORIZATION(data.headers.authorization);
        this.$message({
          message: "登录成功",
          type: "success"
        });
        this.$router.push(this.$route.query.redirect || "/");
      }
    },
    // 账号密码登录
    checkLogin() {
      this.$refs["loginForm1"].validate(valid => {
        if (valid) {
          this.handleLogin();
        } else {
          return false;
        }
      });
    },
    async handleLogin() {
      let loginData = Object.assign({}, this.loginForm1);
      //md5 加密 并大写
      loginData.passWord = md5(loginData.passWord).toUpperCase();
      let data = await sendLoginInfo(loginData);
      // 用户信息存储
      if (data.status === 200) {
        // 不需要权限 删除auth属性
        let userinfo = JSON.parse(data.headers.userinfo);
        delete userinfo.auth;
        this.SET_USERINFO(userinfo);
        this.SET_AUTHORIZATION(data.headers.authorization);
        this.$message({
          message: "登录成功",
          type: "success"
        });
        this.$router.push(this.$route.query.redirect || "/");
      }
    },
    //忘记密码
    forgetPwd() {
      this.pwdDialogVisible = true;
    },
    forgetpwdClosed(isclosed) {
      if (isclosed.closed == true) {
        this.pwdDialogVisible = false;
      }
    },
    // 马上注册
    goRegister() {
      this.dialogVisible = true;
    },
    registerClosed(isclosed) {
      if (isclosed.closed == true) {
        this.dialogVisible = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$light_gray: #fff;
$cursor: #fff;
$dark_gray: #889aa4;
@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}
.login-container {
  // min-height: 100%;
  height: 100%;
  width: 100%;
  // background: url("../../assets/img/login/login-bg.png");
  background: #ffffff;
  // background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  // flex-direction: column;
  .left {
    flex: 3;
    background: #f38e62;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .right {
    flex: 2;
    height: 100%;
    box-sizing: border-box;
    /deep/ .el-tabs__header {
      margin: 0 324px 10px;
    }
  }
  /deep/ .el-tabs__item {
    color: #7d7e7e;
    font-size: 16px;
  }
  /deep/ .el-tabs__item.is-active {
    color: #f38e62;
  }
  /deep/ .el-tabs__active-bar {
    color: #ff854c;
    background-color: #ff854c;
  }
  /deep/ .el-tabs__nav-wrap::after {
    background-color: #33333c;
  }
  /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .tipstyle {
    color: #fff;
    // text-align: center;
    margin-left: 214px;
    .el-button--text {
      font-size: 16px;
      color: #aeaeae;
      margin-right: 160px;
    }
    .register {
      color: #ff854c;
      cursor: pointer;
    }
    .contact {
      margin-top: 230px;
      margin-left: 82px;
    }
    .suggest {
      margin-top: 36px;
      margin-left: 46px;
      color: #b1b0b0;
    }
  }
  .formstyle /deep/ .el-input {
    display: inline-block;
    height: 40px;
    background: #ffffff;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    input {
      background: transparent;
      // border: 0px;
      -webkit-appearance: none;
      border-radius: 25px;
      // color: $light_gray;
      color: #000;
      height: 50px;
      box-sizing: border-box;
      // caret-color: $cursor;
      caret-color: #000;
      &:-webkit-autofill {
        // box-shadow: 0 0 0px 1000px #fff inset !important;
        // -webkit-text-fill-color: $cursor !important;
      }
    }
  }
  /deep/ .el-form-item__error {
    padding-top: 12px;
    padding-left: 10px;
  }
  .register {
    /deep/ .el-form-item__error {
      padding-top: 4px;
    }
  }
  /deep/ .el-input__prefix {
    left: 18px;
  }
  /deep/ .el-input--prefix .el-input__inner {
    padding-left: 50px !important;
  }
  /deep/ .el-form-item {
    border-radius: 5px;
    color: #454545;
    margin-bottom: 30px;
    // width: 500px;
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }
  .login-form {
    position: relative;
    width: 500px;
    max-width: 100%;
    padding: 30px 35px 0;
    margin: 0 150px;
    overflow: hidden;
  }
  .svg-container {
    padding: 0 0 0 10px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    height: 40px;
    background: #ffffff;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    .icon {
      height: 24px;
      width: 24px;
      color: #fff;
      vertical-align: middle;
    }
  }
  .title-container {
    position: relative;
    text-align: center;
    margin-top: 200px;
    margin-bottom: 50px;
    font-size: 30px;
    color: #f38e62;
    // img {
    //   height: 120px;
    //   width: auto;
    // }
  }
  .get-code-btn {
    background: rgb(255, 133, 76);
    border-color: rgb(255, 133, 76);
    margin-left: 8px;
  }
}
</style>